const state = {
    loading: {}
};

const mutations = {
    setLoading(state, key) {
        state.loading = {
            ...state.loading,
            [key]: true
        };
    },
    unsetLoading(state, key) {
        state.loading = { ...state.loading };
        delete state.loading[key];
    }
};

const getters = {
    loading: state => state.loading,
};

export default {
    state,
    mutations,
    getters,
};
